<template>
    <div class="data-panel">
        <div class="data-panel-header">
            <a-tabs :activeKey="type" @change="changeTab" v-if="conf.tabs">
                <a-tab-pane :tab="tab.name" :key="tab.id" v-for="tab in conf.tabs"></a-tab-pane>
            </a-tabs>
            <h2 v-else>{{title}}</h2>
            <div class="extra">
                <template v-if="display === 'table'">
                    <a-button @click="exportToExcel(`${api}_table`, `${$service.PROJ_CODE}-${title}-${conf.date?date.format('YYYY-MM-DD'):`${date_range[0].format('YYYY-MM-DD')}-${date_range[1].format('YYYY-MM-DD')}`}`)" :title="$t('common.downloadData')"><a-icon type="download"/></a-button>
                    <a-button @click="copy(`${api}_table`)" id="copy-btn" style="margin:0 16px 0 8px;" :title="$t('common.copyData')"><a-icon type="copy"/></a-button>
                </template>
                <server :single="true" style="display:inline-block; width:auto; margin:0 8px 0 0;" v-model="server" v-if="conf.server"/>
                <a-date-picker v-model="date" :allowClear="false" v-if="conf.date"/>
                <template v-else>
                    <a-range-picker class="date_range_picker" v-model="date_range" :allowClear="false" :ranges="ranges" v-if="$service.PROJ_CODE!='l28'"/>
                    <RangePicker class="date_range_picker" v-model="date_range" :defaultValue="date_range" v-else style="width:300px; display: inline-block;"/>
                </template>
                <a-radio-group v-model="display" style="margin:0 0 0 16px;" v-if="!this.conf.nodisplay">
                    <a-radio-button value="chart">{{ $t('common.chart') }}</a-radio-button>
                    <a-radio-button value="table">{{ $t('common.table') }}</a-radio-button>
                </a-radio-group>
            </div>
        </div>
        <div class="data-panel-content fixed-data-panel-content">
            <!-- ltv自定义legend -->
            <div class="g2-legend chart_legend" style="display:block" v-if="api=='pay_ltv' && display=='chart'">
                <h4 class="g2-legend-title"></h4>
                <ul class="g2-legend-list" style="list-style-type:none;margin:0;padding:0; text-align:center">
                    <li class="g2-legend-list-item" style="cursor: pointer;font-size: 14px; display: inline-block; margin:0 10px"  @click="hideLtvLegend(field.id)" v-for="field in chart.y" :key="field.id">
                        <div class="g2-legend-marker-container">
                            <i class="g2-legend-marker"></i>
                        </div>
                        <i :class="`g2-custom-marker g2-${field.type=='line'?'line':'bar'}-marker checked`" :style="{backgroundColor: field.color}" v-if="field.visible!=false"></i>
                        <i :class="`g2-custom-marker g2-${field.type=='line'?'line':'bar'}-marker unChecked`" style="background-color: #bfbfbf;" v-else></i>
                        <span class="g2-legend-text">{{field.title}}</span>
                    </li>
                </ul>
            </div>
            <a-spin :spinning="loading" tip="数据加载中..." class="loading" >
                <chart :datas="chart_datas" :fields="fields" :conf="chart" :height="350" v-if="!conf.nodisplay || (conf.nodisplay && conf.display==='chart')" class="fixed-chart" :class="{hidepanel:display!=='chart'}"/>
                <data-table :datas="table_datas" :fields="fields"  :ref="`${api}_table`" v-if="!conf.nodisplay || (conf.nodisplay && conf.display==='table')" class="fixed-datatable"
                    :liucun="conf.table?conf.table.liucun:false" 
                    :pageSize="conf.table?conf.table.page_size:10" 
                    :class="`${conf.table?conf.table.class:''} ${display!=='table'?'hidepanel':''}`" />
            </a-spin>
        </div>
    </div>
</template>

<script>
import moment from "moment"

import Vue from 'vue'
import {Tabs} from 'ant-design-vue';
Vue.use(Tabs)

import Server from '@/components/common/search/server.vue'
import Chart from '@/components/common/chart/chart.vue'
import DataTable from '@/components/common/datatable.vue'
import {datatableMixin} from '@/components/common/datatable/datatableMixin.js'
import RangePicker from "@/components/common/search/range_picker.vue";

export default {
    name: 'commonPanel',
    mixins: [datatableMixin],
    inject: ['today', 'yesterday', 'ranges'],
    components: {
        Chart, DataTable, Server, RangePicker
    },
    props: {
        // 数据接口
        api: {
            type: String,
        },
        // 标题
        title: {
            type: String,
            default: "数据展示",
        },
        // 字段
        fields: {
            type: Array,
            default: ()=>{return []},
        },
        // 图表配置
        chart: {
            type: Object,
            default: ()=>{return {}},
        },
        // 其他配置条件
        conf: {
            type: Object,
            default: ()=>{return {}},
        },
        searchers: {
            type: Object,
            default: ()=>{return {}},
        }
    },
    data() {
        return {
            loading: true,
            display: this.conf.display?this.conf.display:'chart',
            type: this.conf.tabs && this.conf.tabs.length>0?this.conf.tabs[0].id:null,
            date_range: [moment(this.yesterday).subtract(this.conf.range?this.conf.range:27, 'day'), this.yesterday],
            date: this.yesterday,
            server: null,
            datas: [],
            chart_datas: [],
        }
    },
    mounted() {
        // 处理时间
        if(this.searchers.date_range && this.searchers.date_range.default) {
            this.date_range = [moment(this.searchers.date_range.default[0]), moment(this.searchers.date_range.default[1])]
        }
        // 处理时间
        if(this.searchers.date && this.searchers.date.default) {
            this.date = moment(this.searchers.date.default)
        }
        this.getData()
    },
    computed: {
        table_datas() {
            const _datas = this.$_.orderBy(this.datas, ['dt'], ['desc'])
            if(this.conf.table && this.conf.table.liucun) {
                const _tmp = []
                _datas.forEach(d=>{
                    if(d.dt === '汇总') {
                        d.ds = this.$t('dataTable.summary')
                    }
                    if(d.weekday && d.weekday_num!=null) {
                        d.weekday = `<span class="weekday ${d.weekday_num===6 || d.weekday_num===7?'weekend':''}">${this.$t(`week.short_${d.weekday_num}`)}</span>`
                    }
                    _tmp.push(d)
                })
                return _tmp
            }
            return _datas
        }
    },
    watch: {
        date_range(newV) {
            if(newV && newV.length>=2) {
                this.getData()
            }
        },
        date(newV) {
            if(newV) {
                this.getData()
            }
        },
        server(newV) {
            this.getData()
        }
    },
    methods: {
        // 获取数据
        getData() {
            this.loading = true
            let params = {
                start_dt:this.date_range[0].format('YYYY-MM-DD'), 
                end_dt:this.date_range[1].format('YYYY-MM-DD')
            }
            if(this.conf.date) {
                params.dt = this.date.format('YYYY-MM-DD')
            }
            else {
                params.start_dt = this.date_range[0].format('YYYY-MM-DD')
                params.end_dt = this.date_range[1].format('YYYY-MM-DD')
            }
            if (this.conf.server) {
                params.server = this.server
            }
            if (this.conf.tabs) {
                params.type = this.type
            }
            this.$service.query_fixed_module(this.api, params).then((data)=>{
                if(this.conf.pre_handler) {
                    data = this.conf.pre_handler(data, this.chart)
                    this.chart_datas = data
                }
                else {
                    this.chart_datas = data
                }
                if(this.conf.after_handler) {
                    this.datas = this.conf.after_handler(data)
                }
                else {
                    this.datas = data
                }
                // console.log(`chart_datas: `, this.chart_datas);
                this.loading = false
            })
        },
        // tab类扩展
        changeTab(type) {
            this.type = type
            if(this.conf.tab_handler) {
                this.conf.tab_handler(type, this.fields)
            }
            this.getData()
        },
        // ltv单独扩展内容
        hideLtvLegend(id) {
            let index = _.findIndex(this.chart.y, {id})
            if(index >=0 ) {
                let field = this.chart.y[index]
                field.visible = field.visible==false?true:false
                this.chart.y.splice(index, 1, Object.assign({}, field))
                let newdata = []
                this.datas.forEach(row=>{
                    let empty = true
                    this.chart.y.forEach((y)=>{
                        if(y.visible!=false && row[y.id]!=null) {
                            empty = false
                        }
                    })
                    if(!empty) {
                        newdata.push(row)
                    }
                })
                if(newdata.length > 14) {
                    this.chart.x.id = 'ds'
                }
                else {
                    this.chart.x.id = 'dt'
                }
                this.chart_datas = newdata
            }
        }
    }
}
</script>

<style lang="less">
.new_liucun_table {
    span.weekday {
        min-width: 20px;
        height: 20px;
        line-height: 20px;
        background:#dfdfdf;
        border-radius: 20px;
        display: inline-block;
        font-size:12px;
        text-align: center;
        &.weekend {
            background:#7190ff;
            color:#fff;
        }
    }
    .summary_td {
        border-top:1px solid #000;
        border-bottom:1px solid #000;
    }
    .liucun_bold_td {
        font-weight: bold
    }
}
</style>